<div class="page-container">
  <ng-container *ngIf="learnset">
    <div class="header">
      <app-text-input formControlName="learnsetName" [control]="getControl('learnsetName')" [inputName]="'learnset-name'" [label]="'Lernset-Name' | translate" type="text" [placeholder]="'Name des Lernsets eingeben' | translate"></app-text-input>
    </div>
  </ng-container>
</div>

<div class="footer">
  <app-button [text]="'Änderungen speichern' | translate" [loading]="isSaving" (clickEvent)="updateLearnset()"></app-button>
</div>
